// extracted by mini-css-extract-plugin
export default {"price":"price_price__o72Bh","membershipPeriod":"price_membershipPeriod__K3JGI"};